import {Component, inject, OnInit} from '@angular/core';
import {
  ControlContainer,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
} from '@angular/forms';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {TranslateModule} from '@ngx-translate/core';
import {EmMoreInfoModule} from '@em/shared/ui';

@Component({
  selector: 'em-outliers-filter',
  templateUrl: './outliers-filter.component.html',
  styleUrls: ['./outliers-filter.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatSlideToggleModule,
    EmMoreInfoModule,
  ],
})
export class EmOutliersFilterComponent implements OnInit {
  private readonly _controlContainer = inject(ControlContainer);
  formGroup: UntypedFormGroup | null | undefined;

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as UntypedFormGroup;
  }
}
